import React, { useState } from"react";
import axios from"axios";
import { Box, Button, Grid, TextField, Typography, CircularProgress } from"@mui/material";
import API_BASE_URL from"../Config/config";

// Using API from config

const ForgotPassword = () => {
 const [email, setEmail] = useState("");
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState("");
 const [error, setError] = useState("");

 const handleForgotPassword = async (e) => {
 e.preventDefault();
 setLoading(true);
 setMessage("");
 setError("");

 try {
      const res = await axios.post(`${API_BASE_URL}/user/forgot-password`, { email });

      setMessage(res.data.message || "Reset link sent. Check your inbox.");
    } catch (err) {
      console.error("Forgot password error:", err);
      const serverError = err.response?.data?.error;
      const serverMessage = err.response?.data?.message;
      
      setError(
        serverError || serverMessage || "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
 };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: "100vh",
        backgroundColor: "var(--bg-main)",
        py: 4,
      }}
    >
      <Grid item xs={11} sm={10} md={6} lg={4}>
        <Box
          sx={{
            borderRadius: { xs: 4, sm: 4 },
            boxShadow: "0 20px 50px rgba(31, 138, 203, 0.15)",
            overflow: "hidden",
            backgroundColor: "var(--bg-card)",
            color: "var(--text-body)",
            px: { xs: 3, sm: 4 },
            py: { xs: 4, sm: 5 },
            border: "1px solid var(--accent-gray)",
          }}
        >
          <Typography
            variant="h4"
            align="center"
            sx={{ 
              fontWeight: 900, 
              color: "var(--text-heading)", 
              mb: 2, 
              letterSpacing: "-0.02em",
              fontSize: { xs: "1.75rem", sm: "2.125rem" }
            }}
          >
            Forgot Password
          </Typography>
          <Typography align="center" sx={{ color: "var(--text-muted)", mb: 4, fontWeight: 500, fontSize: { xs: "0.9rem", sm: "1rem" } }}>
            Enter your registered email to receive a reset link.
          </Typography>

          {message && (
            <Typography align="center" sx={{ color: "#10b981", mb: 2, fontWeight: "bold" }}>
              {message}
            </Typography>
          )}

          {error && (
            <Typography align="center" sx={{ color: "#ef4444", mb: 2, fontWeight: "bold" }}>
              {error}
            </Typography>
          )}

          <form onSubmit={handleForgotPassword}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              required
              InputProps={{ sx: { backgroundColor: "var(--bg-main)", color: "var(--text-heading)", fontWeight: 600, borderRadius: "12px" } }}
              InputLabelProps={{ sx: { color: "var(--text-muted)", fontWeight: 600 } }}
              sx={{ 
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "var(--accent-gray)" },
                  "&:hover fieldset": { borderColor: "var(--primary-blue)" },
                  "&.Mui-focused fieldset": { borderColor: "var(--primary-blue)" },
                }
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                backgroundColor: "var(--primary-blue)",
                color: "#fff",
                fontWeight: 800,
                py: 2,
                borderRadius: "12px",
                textTransform: "none",
                fontSize: "1.1rem",
                boxShadow: "0 10px 20px rgba(43, 176, 230, 0.3)",
                "&:hover": {
                  backgroundColor: "var(--secondary-blue)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 12px 25px rgba(31, 138, 203, 0.4)",
                },
                transition: "all 0.2s"
              }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Send Reset Link"}
            </Button>
          </form>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;



